import React from "react";
import video from "../../../Assets/Home/video.mp4";
import icon1 from '../../../Assets/Home/dumbbell.png';
import icon2 from '../../../Assets/Home/efficiency.png';
import icon3 from '../../../Assets/Home/power.png';



const WhyChooseUs = () => {
  const features = [
    {
      title: "Best Energy Tariffs",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      icon : icon1
    },
    {
      title: "Always Clean Energy",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      icon : icon2
    },
    {
      title: "Robust Experience",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        icon : icon3
    },
  ];

  return (
    <section className="bg-white py-16 px-6 md:px-10 lg:px-12 xl:px-20">
      <div className="grid lg:grid-cols-2 gap-10">
        
        {/* 🎥 Video Section */}
        <div className="relative w-full h-[300px] sm:h-[400px] lg:h-[600px] rounded-2xl overflow-hidden group">
          <video
            src={video}
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />

          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex items-end p-6">
            <h1 className="text-white text-xl sm:text-2xl lg:text-3xl font-bold">
              Sustainable Energy for Future ⚡
            </h1>
          </div>
        </div>

        {/* 📄 Content Section */}
        <div className="lg:mt-6">
          {/* Header */}
          <div className="mb-10 text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
              <div className="h-px w-10 bg-green-400" />
              <span className="text-green-500 font-bold font-rajdhani text-sm tracking-widest uppercase">
                Why Choose Us
              </span>
              <div className="h-px w-10 bg-green-400" />
            </div>

            <h2 className="text-2xl md:text-4xl lg:text-[45px] font-rajdhani font-bold text-gray-900 mb-4 leading-snug">
              We Are Building a Sustainable Future
            </h2>

            <p className="text-gray-600 text-sm sm:text-base max-w-xl mx-auto lg:mx-0">
              We provide clean, efficient, and affordable energy solutions
              designed for a greener tomorrow.
            </p>
          </div>

          {/* Features */}
          <div className="">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex gap-4 p-4 rounded-xl hover:shadow-lg transition-all duration-300 group"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-green-200 rounded-full flex items-center justify-center group-hover:bg-green-100 transition">
                  <img src={feature.icon} alt={feature.title} className="size-8 object-cover" />
                </div>

                {/* Text */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;